import Image from 'next/image'
import { FC } from 'react'

import { IBannerImage } from './data'

import styles from './banner-image.module.scss'

const BannerImage: FC<IBannerImage> = (imgData) => {
  return (
    <div className={styles.imageWrapper}>
      <Image className={styles.image} width="350" height="487" {...imgData} unoptimized />
    </div>
  )
}

export default BannerImage
